import React, { useState } from 'react';
import { Field, useFormikContext } from 'formik';

import {
  InputUI,
  AutoCompleteSelectUI,
  FormLabelUI,
  FormErrorUI,
  ChromeColorPickerUI,
  ButtonUI,
  CheckboxUI,
} from '../Interface';
import { Box, Popover, Typography } from '@mui/material';
import useParam from '../../context/ParamContext';

export const FormFields = ({ viewField, selectedValues, autoCompleteData, autoCompleteOptions }) => {
  const { params } = useParam();
  const { values, validateField, setFieldValue, errors } = useFormikContext();
  const [anchorEl, setAnchorEl] = useState(null);

  const handlePopoverOpen = (event) => {
    if (!viewField) {
      setAnchorEl(event.currentTarget);
    }
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'color-popover' : undefined;

  return (
    <div className="grid grid-cols-4 gap-x-4 mx-4 mb-5">
      <div className="col-span-4 ">
        <Field
          type="text"
          name="nickName"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Név" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.nickName} />}
          InputLabelProps={{ shrink: values.nickName && values.nickName !== '' }}
          disabled={viewField}
        />
      </div>
      <div className="col-span-4 md:col-span-2">
        <Field
          type="text"
          name="userName"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Felhasználónév" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.userName} />}
          disabled={viewField}
          InputLabelProps={{ shrink: values.userName && values.userName !== '' }}
        />
      </div>
      <div className="col-span-4 md:col-span-2">
        <Field
          type="password"
          name="password"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Jelszó" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.password} />}
          disabled={viewField}
          InputLabelProps={{ shrink: values.password && values.password !== '' }}
        />
      </div>
      <div className="col-span-4 md:col-span-1">
        <Field
          type="text"
          name="pinCode"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="PIN Kód" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.pinCode} />}
          disabled={viewField}
          InputLabelProps={{ shrink: values.pinCode && values.pinCode !== '' }}
        />
      </div>
      <div className="col-span-4 md:col-span-1">
        <Field
          type="autocomplete"
          name="activeId"
          component={AutoCompleteSelectUI}
          fullWidth
          label={<FormLabelUI text="Aktív" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.activeId} />}
          onChange={(_e, newVal) => {
            setFieldValue('activeId', newVal?.value ?? null).then(() => {
              validateField('activeId');
            });
          }}
          disabled={viewField}
          InputLabelProps={{ shrink: values.activeId !== '' }}
          selectedValue={values.activeId}
          selectedLabelValue={selectedValues?.webuserarchive?.arhiveName}
          dataset={autoCompleteOptions?.webUserArchive}
        />
      </div>
      <div className="col-span-4 md:col-span-2">
        <Field
          type="autocomplete"
          name="roleId"
          component={AutoCompleteSelectUI}
          fullWidth
          label={<FormLabelUI text="Jogosultsági csoport" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.roleId} />}
          onChange={(_e, newVal) => {
            setFieldValue('roleId', newVal?.value ?? null).then(() => {
              validateField('roleId');
            });
          }}
          disabled={viewField}
          InputLabelProps={{ shrink: values.roleId !== '' }}
          selectedValue={values.roleId}
          selectedLabelValue={selectedValues?.roles?.roleName}
          dataset={autoCompleteOptions?.roleList}
        />
      </div>
      <div className="col-span-4 md:col-span-2">
        <Field
          type="autocomplete"
          name="homePage"
          component={AutoCompleteSelectUI}
          fullWidth
          label={<FormLabelUI text="Kezdőképernyő" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.homePage} />}
          onChange={(_e, newVal) => {
            setFieldValue('homePage', newVal?.value ?? null);
            validateField('homePage');
          }}
          disabled={viewField}
          InputLabelProps={{ shrink: values.homePage !== '' }}
          selectedValue={values.homePage}
          selectedLabelValue={selectedValues?.homePage}
          dataset={autoCompleteData}
        />
      </div>
      <div className="col-span-4 md:col-span-1">
        <Field
          type="number"
          name="costPerHour"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Költség /óra" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.costPerHour} />}
          disabled={viewField}
          InputLabelProps={{ shrink: values.costPerHour && values.costPerHour !== '' }}
        />
      </div>
      <div className="col-span-4 md:col-span-1">
        <Field
          type="text"
          name="email"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Email" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.email} />}
          disabled={viewField}
          InputLabelProps={{ shrink: values.email !== '' }}
        />
      </div>
      <div className="col-span-4 md:col-span-1">
        <Field
          type="text"
          name="phoneNumber"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Telefonszám" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.phoneNumber} />}
          disabled={viewField}
          InputLabelProps={{ shrink: values.phoneNumber !== '' }}
        />
      </div>
      <div className="md:col-span-1 col-span-4 pt-4">
        <div
          className={`${!viewField ? 'cursor-pointer' : 'cursor-not-allowed'} rounded-full shadow-[rgba(0,_0,_0,_0.54)_0px_1px_8px] w-[20px] h-[20px] mt-1`}
          style={{ background: values.color }}
          onClick={handlePopoverOpen}
        />
        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handlePopoverClose}
          anchorOrigin={{
            vertical: 'center',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'center',
            horizontal: 'left',
          }}
        >
          <ChromeColorPickerUI
            color={values.color}
            onChange={(color) => {
              setFieldValue('color', color.hex);
            }}
            removeColor={() => {
              setFieldValue('color', '');
              handlePopoverClose();
            }}
          />
        </Popover>
      </div>
      {params.USER_SHOW_NOTIFYONNEWPROJECT_FIELD === 'Y' && (
        <div className="md:col-span-2 col-span-4 pt-3">
          <Field
            name="notifyOnNewProject"
            type="checkbox"
            as={CheckboxUI}
            fullWidth
            label={<FormLabelUI text="Új projekt felvitelről értesítés küldése" />}
            disabled={viewField}
          />
        </div>
      )}
    </div>
  );
};
